// extracted by mini-css-extract-plugin
module.exports = {"page":"ErrorPage_page__GQksy"};